import { useQuery } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { getProfileByIdApi } from './api';

const useUser = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { data, isInitialLoading } = useQuery(['myProfile'], getProfileByIdApi, {
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
    keepPreviousData: true,
  });

  return {
    iconId: data?.data?.iconId,
    email: data?.data?.email,
    id: data?.data?.id,
    name: data?.data?.name,
    role: data?.data?.role,
    surname: data?.data?.surname,
    username: data?.data?.username,
    facilityId: data?.data?.facilityId,
    vendorId: data?.data?.vendorId,
    isLoading: isInitialLoading,
  };
};

export default useUser;
